export function promiseTimeout(promise, millis, rejection = new Error('Timeout')) {
    if (millis === Number.POSITIVE_INFINITY) {
        return promise;
    }
    if (millis <= 0) {
        return Promise.reject(rejection);
    }
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            reject(rejection);
        }, millis);
        promise.then(resolve, reject);
    });
}
//# sourceMappingURL=timeout.js.map